import { ExecutionBriefWorkOrdersState } from "../../types/execution-brief-work-orders/execution-brief-work-orders.interface";
import { createExecutionBriefWorkOrdersState } from "../../types/execution-brief-work-orders/execution-brief-work-orders.functions";

import {
  ExecutionBriefWorkOrdersActions,
  ExecutionBriefWorkOrdersActionTypes,
} from "./execution-brief-work-orders.actions";

export function executionBriefWorkOrdersReducer(
  state = createExecutionBriefWorkOrdersState(),
  action: ExecutionBriefWorkOrdersActionTypes
): ExecutionBriefWorkOrdersState {
  switch (action.type) {
    case ExecutionBriefWorkOrdersActions.FetchWorkOrders:
      return {
        errors: null,
        loading: true,
        results: [],
      };
    case ExecutionBriefWorkOrdersActions.FetchWorkOrdersFailure:
      return {
        ...state,
        errors: action.payload,
        loading: false,
      };
    case ExecutionBriefWorkOrdersActions.FetchWorkOrdersSuccess:
      return {
        ...state,
        loading: false,
        results: action.payload.results,
      };

    default:
      return state;
  }
}
